module.exports = __webpack_public_path__ + "img/half-circle-1.30f0d22d.svg";